import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@tanium/react-box';
import { Stack } from '@tanium/react-stack';
import { ThemeColors } from '@tanium/theme-data';
import TaniumLogo from '../../static/tanium_logo.svg';

export const TaniumLoginCard: React.FC = ({ children }) => {
  const { t } = useTranslation('app');
  return (
    <Box as={Stack} fill borderRadius="8px" minHeight="400px" width="800px" boxShadow="Overlay2">
      <Box borderLeftRadius="8px" bg={ThemeColors.Dark0} height="100%" display="flex" alignItems="center">
        <img src={TaniumLogo} alt={t('taniumLogoImgAlt')} height="60px" width="100%" />
      </Box>
      <Box
        borderRightRadius="8px"
        bg={ThemeColors.FillLevel2}
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        fontSize="14px"
      >
        <Box width="250px" py={2}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};
